module.exports = "/_next/static/images/dallas-fast-channel-description-image-black-letters-c5b69b637b347507129b5ada11645518.svg";